export default "__VITE_ASSET__y5AsV0E2__"